import { Li } from "styles/jss/Layout.styles";
import { Steps } from "styles/jss/FormPages.styles";
import { useRouter } from "next/router";
import { createRef, useState } from "react";
// import { Box, Step, Stepper as MuiStepper, StepLabel } from "@mui/material";

export default function Stepper({ steps, active }) {
  const { locale } = useRouter();
  const ref = createRef();

  const [startY, setStartY] = useState(0);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [scrollTop, setScrollTop] = useState(0);
  const [isDown, setIsDown] = useState(false);

  function onMouseDown(e) {
    setIsDown(true);
    setStartY(e.pageY - ref.current.offsetTop);
    setStartX(e.pageX - ref.current.offsetLeft);
    setScrollLeft(ref.current.scrollLeft);
    setScrollTop(ref.current.scrollTop);
  }
  function onMouseUp(e) {
    setIsDown(false);
  }
  function onMouseLeave(e) {
    setIsDown(false);
  }
  function onMouseMove(e) {
    if (isDown) {
      e.preventDefault();
      //Move vertcally
      const y = e.pageY - ref.current.offsetTop;
      const walkY = y - startY;
      ref.current.scrollTop = scrollTop - walkY;

      //Move Horizontally
      const x = e.pageX - ref.current.offsetLeft;
      const walkX = x - startX;
      ref.current.scrollLeft = scrollLeft - walkX;
    }
  }

  return (
    <Steps
      locale={locale === "fa"}
      ref={ref}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseMove={onMouseMove}
      onMouseLeave={onMouseLeave}
    >
      {steps.map(item => (
        <Li
          key={item.id}
          className={
            active === item.id ? "active" : active > item.id ? "passed" : ""
          }
        >
          <span>{item.id}</span>
          {item.title}
        </Li>
      ))}
    </Steps>
    // <Box sx={{ width: "100%" }}>
    //   <MuiStepper activeStep={1} alternativeLabel>
    //     {steps?.map(item => (
    //       <Step key={item.id}>
    //         <StepLabel>{item.title}</StepLabel>
    //       </Step>
    //     ))}
    //   </MuiStepper>
    // </Box>
  );
}
